import { NATIVE_TOKEN_ADDRESS, WRAPPED_GAS_TOKENS } from '@src/configs/chainInfo'
import { getGasTokenSymbol } from '@src/configs/chainInfo'
import { ChainId } from '@src/configs/chainInfo'
import { Address, IToken } from '@src/types/token'
import { bigintPow } from '@src/utils'

export const HARDCODED_TESTNET_TOKENS: IToken[] = [
    {
        address: '0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238' as Address,
        symbol: 'USDC',
        name: 'USDC',
        logoURI: 'https://coin-images.coingecko.com/coins/images/6319/large/usdc.png?1696506694',
        price_current: 1,
        decimals: 6,
        chainId: ChainId.Sepolia,
        native: false,

        // Dummy balance
        userBalance: BigInt(100) * bigintPow(BigInt(10), BigInt(6)),
        userBalanceInUSD: 1000,
    },
    {
        symbol: `${getGasTokenSymbol('sepolia')}`,
        logoURI: `/assets/token/${getGasTokenSymbol('sepolia').toLowerCase()}.png`,
        name: `${getGasTokenSymbol('sepolia')}`,
        chainId: ChainId.Sepolia,
        address: NATIVE_TOKEN_ADDRESS[ChainId.Sepolia],
        decimals: 18,
        native: true,
        wrapped: false,

        // Dummy balance
        userBalance: BigInt(100) * bigintPow(BigInt(10), BigInt(18)),
        userBalanceInUSD: 1000,
    },
    {
        symbol: `W${getGasTokenSymbol('sepolia')}`,
        logoURI: `/assets/token/w${getGasTokenSymbol('sepolia').toLowerCase()}.png`,
        name: `W${getGasTokenSymbol('sepolia')}`,
        chainId: ChainId.Sepolia,
        address: WRAPPED_GAS_TOKENS[ChainId.Sepolia].address,
        decimals: 18,
        native: false,
        wrapped: true,

        // Dummy balance
        userBalance: BigInt(100) * bigintPow(BigInt(10), BigInt(18)),
        userBalanceInUSD: 1000,
    },
    {
        address: '0x88b8E2161DEDC77EF4ab7585569D2415a1C1055D' as Address,
        symbol: 'USDT',
        name: 'USDT',
        logoURI: 'https://assets.coingecko.com/coins/images/325/standard/Tether.png?1696501661',
        price_current: 1,
        decimals: 6,
        chainId: 10143,
        native: false,

        // Dummy balance
        userBalance: BigInt(100) * bigintPow(BigInt(10), BigInt(6)),
        userBalanceInUSD: 1000,
    },
    {
        symbol: `${getGasTokenSymbol('monadtestnet')}`,
        logoURI: `/assets/token/${getGasTokenSymbol('monadtestnet').toLowerCase()}.png`,
        name: `${getGasTokenSymbol('monadtestnet')}`,
        chainId: ChainId.MonadTestnet,
        address: NATIVE_TOKEN_ADDRESS[ChainId.MonadTestnet],
        decimals: 18,
        native: true,
        wrapped: false,

        // Dummy balance
        userBalance: BigInt(100) * bigintPow(BigInt(10), BigInt(18)),
        userBalanceInUSD: 1000,
    },
    {
        symbol: `W${getGasTokenSymbol('monadtestnet')}`,
        logoURI: `/assets/token/w${getGasTokenSymbol('monadtestnet').toLowerCase()}.png`,
        name: `W${getGasTokenSymbol('monadtestnet')}`,
        chainId: ChainId.MonadTestnet,
        address: WRAPPED_GAS_TOKENS[ChainId.MonadTestnet].address,
        decimals: 18,
        native: false,
        wrapped: true,

        // Dummy balance
        userBalance: BigInt(100) * bigintPow(BigInt(10), BigInt(18)),
        userBalanceInUSD: 1000,
    },
]
